import { useLayoutEffect } from "react";
import {
  useShowProductPictures,
  useProjectTree,
  useProjectUIActions,
  useTreeRef,
} from "stores/project";

export const useRedraw = () => {
  const projectTree = useProjectTree();
  const showProductPictures = useShowProductPictures();
  const actions = useProjectUIActions();
  const treeRef = useTreeRef();

  // This layout effect is used to redraw the list when the project tree is updated.
  useLayoutEffect(() => {
    if (!treeRef || !treeRef.current) {
      return;
    }
    actions.redrawList();
  }, [actions, projectTree, showProductPictures, treeRef]);
};
